export function withInlineVoidElement(editor: any, type: string, makeVoid = false) {
  const { isInline, isVoid } = editor;

  editor.isInline = (element: any) => (element.type === type ? true : isInline(element));

  if (makeVoid) {
    editor.isVoid = (element: any) => (element.type === type ? true : isVoid(element));
  }

  return editor;
}

// This function mark element or node as block and block with void
export function withBlockVoidType(editor: any, type: string, makeVoid = false) {
  const { isBlock, isVoid } = editor;

  editor.isBlock = (element: any) => (element.type === type ? true : isBlock(element));

  if (makeVoid) {
    editor.isVoid = (element: any) => (element.type === type ? true : isVoid(element));
  }
  return editor;
}
